<script>
export default {
  props: {
    label: String,
    href: String,
    to: String,
    icon: String,
    value: Boolean,
  },
};
</script>
<template>
  <v-list-item
    :title="label"
    :href="href"
    :to="to"
    :value="value"
    link
  >
    <v-list-item-action>
      <v-icon>{{ icon }}</v-icon>
    </v-list-item-action>
    <v-list-item-content>
      <v-list-item-title>{{ label }}</v-list-item-title>
    </v-list-item-content>
  </v-list-item>
</template>
